import React from 'react'
import { ITextBoxProps, TextBox } from './TextBox'

interface INumberTextBoxProps extends ITextBoxProps {
  value?: string
  onChange: (value: number | string) => void
}

const NumberTextBox: React.FC<INumberTextBoxProps> = ({
  value = '',
  onChange,
  ...props
}) => (
  <TextBox
    value={`${value}`}
    type="number"
    onChange={(ev) => {
      const v = ev.target.value
      if (v === '') {
        onChange('')
        return
      }
      if (v && !isNaN(v)) {
        onChange(parseFloat(v))
      }
    }}
    {...props}
  />
)

export { NumberTextBox }
